/* This file is generated by scripts/generate-build-meta.js. */
export const GENERATED_BUILD_META = Object.freeze({
  "version": "1.6.10",
  "buildId": "20260717-1711-4faaa52",
  "builtAt": "2026-07-17T11:41:15.954Z"
});
